import PushNotificationsScreen from './PushNotificationsScreen';

export default PushNotificationsScreen;
